
import Vue from "vue";
import { route_castLogin, route_guestLogin } from "@/router";
export default Vue.extend({
  data(): {
    drawer: boolean;
  } {
    return {
      drawer: false,
    };
  },
  methods: {
    async logout() {
      let redirect_path = route_guestLogin;
      if(this.$store.getters['auth/isCast']){
        redirect_path = route_castLogin;
      }
      await this.$store.dispatch("auth/signOut", redirect_path);
    },
  },
});
